"use client";
import { Image } from "@/components/Image";
import { ArrowRightCircle } from "@/components/newIcons/ArrowRightCircle";
import Link from "next/link";
import type { Departure } from "../../getDeparture";
import { SpeakerClient } from "./SpeakerClient";

type Props = {
  speaker: Departure["speakers"][number];
};
export const Speaker = ({ speaker }: Props) => {
  return (
    <div className="bg-[#FBF7F4] text-primary rounded-[5px] p-5 mt-5 lg:mt-8 lg:min-h-[200px]">
      <div className="lg:pr-[200px] relative">
        <div className="flex">
          <div className="w-[70px] h-[70px] lg:w-[160px] lg:h-[160px] rounded-[5px] overflow-hidden shrink-0 lg:absolute top-0 right-0">
            <Link href={`/conferenciers/${speaker.alias}/`}>
              <Image
                alt={speaker.imageRealname || ""}
                image={{
                  id: speaker.id.toString(),
                  name: speaker.imageName || "",
                  realname: speaker.imageRealname || "",
                  type: "speaker",
                }}
                height={{
                  type: "ratio",
                  value: 100,
                }}
                sizes="350px"
                objectFit="cover"
              />
            </Link>
          </div>
          {speaker.firstname && speaker.lastname && (
            <div className="flex flex-col max-lg:ml-[10px]">
              <p className="text-sm lg:hidden">Avec</p>
              <Link href={`/conferenciers/${speaker.alias}/`} className="text-primary no-underline">
                <h3 className="text-base leading-5 lg:text-xl font-bold cursor-pointer">
                  {speaker.firstname} {speaker.lastname}
                </h3>
              </Link>
            </div>
          )}
        </div>
        {speaker.pickupLine && (
          <h4 className="font-semibold italic text-base lg:text-xl mt-[10px] lg:mt-5">{speaker.pickupLine}</h4>
        )}
        <SpeakerClient>
          {speaker.branchDescription && <p className="mt-5 text-sm lg:text-base">{speaker.branchDescription}</p>}
          {speaker.formations.length !== 0 && (
            <>
              <h4 className="font-bold mt-5 text-sm lg:text-base">Formation</h4>
              <ul className="m-0 p-0 mt-5">
                {speaker.formations.map((formation) => (
                  <li key={formation} className="flex items-center space-x-[10px] mb-[10px] last:mb-0">
                    <ArrowRightCircle className="w-6 h-6 text-[#B95733] shrink-0" />
                    <p className="first-letter:uppercase text-sm lg:text-base">{formation}</p>
                  </li>
                ))}
              </ul>
            </>
          )}
          {speaker.strengths.length !== 0 && (
            <>
              <h4 className="font-bold mt-5 text-sm lg:text-base">Points forts</h4>
              <ul className="m-0 p-0 mt-5">
                {speaker.strengths.map((strength) => (
                  <li key={strength} className="flex items-center space-x-[10px] mb-[10px] last:mb-0">
                    <ArrowRightCircle className="w-6 h-6 text-[#B95733] shrink-0" />
                    <p className="first-letter:uppercase text-sm lg:text-base">{strength}</p>
                  </li>
                ))}
              </ul>
            </>
          )}
        </SpeakerClient>
      </div>
    </div>
  );
};
